import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { fmtUSD } from "./fmt";

const TICK_STYLE = { fontFamily: "IBM Plex Mono", fontSize: 11, fill: "#8a8a8a" };
const Y_DOMAIN = ["dataMin - 0.00002", "dataMax + 0.00002"];
const TOOLTIP_STYLE = {
  background: "#050505",
  border: "1px solid #222",
  borderRadius: 0,
  fontFamily: "IBM Plex Mono",
  fontSize: 12,
};
const yTickFormatter = (v) => (Number(v) || 0).toFixed(6);
const tooltipFormatter = (v) => [`$${(Number(v) || 0).toFixed(8)}`, "SPURR"];

export default function SpurrChart({ price, chart }) {
  const up = (price?.change_24h || 0) >= 0;
  return (
    <div className="col-span-12 lg:col-span-8 border border-[#3a3a3a] bg-[#121212]">
      <div className="flex items-center justify-between px-6 py-4 border-b border-[#3a3a3a] flex-wrap gap-4">
        <div className="flex items-baseline gap-4">
          <div className="font-display font-bold text-lg">SPURR / USD</div>
          <div className="font-mono text-2xl font-bold" data-testid="emg-price">
            ${price?.price?.toFixed(8) || "—"}
          </div>
          <div
            className={`flex items-center gap-1 font-mono text-xs ${
              up ? "text-[#00ff41]" : "text-[#ff3333]"
            }`}
          >
            {up ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />}
            {price?.change_24h?.toFixed(2) || "0.00"}% 24h
          </div>
        </div>
        <div className="flex gap-6 font-mono text-[11px] uppercase tracking-widest">
          <div>
            <div className="text-[#d0d0d0]">M.Cap</div>
            <div className="text-white">{fmtUSD(price?.market_cap)}</div>
          </div>
          <div>
            <div className="text-[#d0d0d0]">Vol 24h</div>
            <div className="text-white">{fmtUSD(price?.volume_24h)}</div>
          </div>
          <div>
            <div className="text-[#d0d0d0]">Holders</div>
            <div className="text-white">{price?.holders?.toLocaleString()}</div>
          </div>
        </div>
      </div>
      <div className="h-80 px-2 pt-4 pb-2">
        <ResponsiveContainer width="100%" height="100%" minWidth={1} minHeight={1} initialDimension={{ width: 320, height: 240 }}>
          <AreaChart data={chart}>
            <defs>
              <linearGradient id="emg-grad" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="#cfff04" stopOpacity={0.55} />
                <stop offset="100%" stopColor="#cfff04" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#1a1a1a" vertical={false} />
            <XAxis
              dataKey="t"
              stroke="#333"
              tick={TICK_STYLE}
              interval={9}
            />
            <YAxis
              stroke="#333"
              tick={TICK_STYLE}
              tickFormatter={yTickFormatter}
              domain={Y_DOMAIN}
            />
            <Tooltip
              contentStyle={TOOLTIP_STYLE}
              formatter={tooltipFormatter}
            />
            <Area
              type="monotone"
              dataKey="p"
              stroke="#cfff04"
              strokeWidth={1.5}
              fill="url(#emg-grad)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
